<template>
    <div class="summary-quantity">
        <div style="display: flex; width: 100%">
            <div style="flex: 1 1 auto">
                <div>
                    Le entregaremos {{ numPlants }} plantas
                    <template v-show="seedsByAlveolus > 0">
                        a {{ seedsByAlveolus }} semilla{{ seedsByAlveolus > 1 ? 's' : '' }} por alvéolo
                    </template>
                </div>
                <div v-for="trayFormat in trayFormatsWithQuantity">
                    en {{ trayFormat.value }} {{ trayFormat.value === 1 ? 'bandeja' : 'bandejas'}} de {{ trayFormat.unidades }} alvéolos
                </div>
            </div>
            <div style="display: flex; align-items: center">
                <img src="/img/iconos/icon_bandeja_custom.svg" alt="Bandeja" style="height: 3em">
            </div>
        </div>
        <div class="save-money">
            <div class="line" v-show="ahorro > 0">
                <div>
                    Está ahorrando
                </div>
                <div>
                    {{ formatMoney(ahorro) }}
                </div>
            </div>
            <div class="line">
                <div>
                    Descuento por volumen
                </div>
                <div>
                    <img class="ahorro_icon" :src="'/img/iconos/icon_descuento_custom'+ahorro_icon+'.svg'" alt="icon_descuento_custom">
                    <i class="fas fa-info-circle cursor_pointer" @mouseover="openInfoWindow('info_descuento')" @mouseleave="openInfoWindow('info_descuento')"></i>
                    <windows-info v-cloak ref="info_descuento" back-color="green" in-product="true">
                        <span slot="header">
                            Se aplicarán los siguientes descuentos por volumen de compra
                            siempre que se trate de un mismo artículo.
                        </span>
                        <span slot="footer">
                            <strong>De 3 a 6 bandejas</strong><br>
                            <span>Descuento de 0,33€ por bandeja</span>
                            <br><br>
                            <strong>De 7 a 11 bandejas</strong><br>
                            <span>Descuento de 0,66€ por bandeja</span>
                            <br><br>
                            <strong>Más de 12 bandejas</strong><br>
                            <span>Descuento de 1,00€ por bandeja</span>
                        </span>
                    </windows-info>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SummaryQuantity",
        props: {
            numPlants: {},
            trayFormats: {
                type: Array,
                default: []
            },
            ahorro: {
                type: Number
            },
            seedsByAlveolus: {
                type: Number
            }
        },
        data() {
            return {
                ahorro_icon: "",
            }
        },
        computed: {
            trayFormatsWithQuantity() {
                return this.trayFormats.filter(tf => tf.value > 0);
            },
            cantidad() {
                let numTrays = this.trayFormatsWithQuantity.map(tf => tf.value);
                let cantidad = 0;
                if (numTrays.length > 0) {
                    cantidad = Math.min(...numTrays);
                }
                return cantidad;
            }
        },
        watch : {
            cantidad: function () {
                this.cantidadChanged();
            },
        },
        methods: {
            openInfoWindow: function (ventana) {
                var window = this.$refs[ventana];
                window.active=!window.active;
            },
            cantidadChanged() {
                let val = this.cantidad;
                if (val>=12) {
                    this.ahorro_icon = 'full';
                }else if (val>=7) {
                    this.ahorro_icon = 'medium';
                }else if (val>=3) {
                    this.ahorro_icon = 'low';
                }else{
                    this.ahorro_icon = '';
                }
                if (val<3) {
                    this.ahorro_block = 'disabled';
                }else{
                    this.ahorro_block = '';
                }
            }
        },
        created() {
            this.cantidadChanged();
        }
    }
</script>

<style scoped>
    .summary-quantity {
        background-color: #d6da2f;
        color: #0671b8;
        padding: 15px 500px;
        text-align: left;
        margin-left: -500px;
        margin-right: -500px;
        display: flex;
        flex-wrap: wrap;
        font-weight: bold;
        margin-top: 1rem;
    }

    .save-money {
        border: 1px solid;
        padding: 0.5rem;
        margin-top: 0.5rem;
        width: 100%;
        flex: 1 1 auto;
        color: #006837;
    }

    .save-money > .line {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    @media (min-width: 992px) {
        .summary-quantity {
            padding: 0.75rem 1.75rem;
            border-radius: 0.25rem;
            border: 1px solid #cbc8c9;
            margin-left: 0;
            margin-right: 0;
        }

        .save-money {
            margin-left: -0.875rem;
            margin-right: -0.875rem;
            padding-left: 0.875rem;
            padding-right: 0.875rem;
            margin-top: 0.875rem;
        }

        /*.save-money > * {*/
        /*    margin-left: 0.5rem;*/
        /*    margin-right: 0.5rem;*/
        /*}*/
    }
</style>
